<template>
    <div class="modal fade" id="ModalForgotPass" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="h5 heading heading_modal" id="ModalForgotPassLabel" v-if="!message">ВОССТАНОВЛЕНИЕ ПАРОЛЯ</p>
                    <button type="button" class="modal-close btn btn-close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"></span>
                    </button>
                </div>
                <div class="modal-body">
                    <form id="ForgotPassForm" method="post" @submit.prevent="submit"
                          action="/ajax_new/Forms/forgotPass/" v-if="!message">
                        <div class="modal-body-content">
                            <div class="form-group form-group_modal" :class="{ 'form-group--error': $v.phone.$error }">
                                <label for="ForgotPassForm_phone">
                                    Телефон
                                    <span class="color-red">*</span>
                                </label>
                                <masked-input class="form-control"
                                              :value="phone"
                                              name="phone"
                                              mask="+7 (999) 999 99 99" placeholder="+7 (___) ___ __ __"
                                              type="tel"
                                              ref="maskedPhone"
                                              id="ForgotPassForm_phone"
                                              @focus="$v.phone.$reset"
                                              @blur="$v.phone.$touch"
                                              @input="setPhone"/>
                                <div class="invalid-input" v-if="!$v.phone.valid">
                                    Неверный номер телефона
                                </div>
                                <div class="invalid-input" v-if="!$v.phone.issetUser && $v.phone.valid">
                                    Пользователя с таким номером не существует
                                </div>
                            </div>
                            <div class="form-group form-group_modal" :class="{ 'form-group--error': $v.code.$error }">
                                <label for="ForgotPassForm_code">
                                    Код из смс
                                    <span class="color-red">*</span>
                                </label>
                                <div class="input-group">
                                    <masked-input class="form-control"
                                                  id="ForgotPassForm_code"
                                                  mask="9999" placeholder="____"
                                                  type="text"
                                                  @focus="$v.code.$reset"
                                                  @blur="$v.code.$touch"
                                                  @input="setCode"
                                                  :value="code"
                                                  ref="maskedCode" aria-describedby="code-addon"/>
                                    <div class="input-group-append code-action" :class="{ 'code-success': $v.code.success }">
                                        <div v-if="$v.code.success" class="text-center">
                                            <span class="color-light-green"><i class="fa fa-check" aria-hidden="true"></i> Подтвержден</span>
                                        </div>
                                        <div v-if="!$v.code.success">
                                            <button v-if="codeTimer > 0" disabled="disabled" type="button" class="btn btn-primary">
                                                <span>{{codeTimer}}</span>
                                            </button>
                                            <button @click="sendCode" type="button" class="btn btn-primary">
                                                отправить код
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="invalid-input" v-if="!$v.code.valid">
                                    Неверный код
                                </div>
                                <div class="invalid-input" v-if="!$v.code.success && $v.code.valid">
                                    Неверный код
                                </div>
                            </div>
                        </div>
                        <div class="form-group form-group_modal policy-personal-data-block">
                            Нажимая на кнопку «Восстановить» вы подтверждаете,
                            что согласны с
                            <a href="/policy-personal-data" class="policy-data" target="_blank">
                                Политикой обработки персональных данных
                            </a>
                        </div>
                        <div class="form-group form-group_modal modal-footer">
                            <button type="submit" class="btn btn-primary btn-block text-white" v-loading="isAjax" :disabled="isAjax">
                                Восстановить
                            </button>
                        </div>
                        <div class="alert alert-dismissable fade show alert-danger" role="alert" v-if="errors.length">
                            {{ errors[0].message }}
                        </div>
                    </form>
                    <div v-if="message">
                        <h3 class="text-center py-3" v-html="message"></h3>
                        <div class="form-group form-group_modal">
                            <button class="btn btn-primary btn-block" data-dismiss="modal">ОК</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import MaskedInput from '../MaskedInput'

  export default {
    name: 'forgot-pass',
    mixins: [validationMixin],
    components: {MaskedInput},
    data: function () {
      return {
        phone: localStorage.getItem("_phone") || '',
        code: '',
        message: '',
        errors: [],
        isUser: false,
        isCodeSend: false,
        isCodeSuccess: false,
        codeErrorMessage: '',
        codeTimer: 0,
        isAjax: false
      }
    },
    computed: {
      phoneValid() {
        if(this.phone.replace(/[^0-9]/g, '').length === 11) {
          this.checkUser()
        }
        return this.phone.replace(/[^0-9]/g, '').length === 11
      },
      codeValid() {
        if (this.code.replace(/[^0-9]/g, '').length === 4) {
          this.checkCode()

          this.$v.code.$touch()
        }

        return this.code.replace(/[^0-9]/g, '').length === 4
      }
    },
    validations: {
      phone: {
        valid () {
          return this.phoneValid
        },
        issetUser () {
          return this.isUser
        }
      },
      code: {
        valid () {
          return this.codeValid
        },
        success () {
          return this.isCodeSuccess
        }
      }
    },
    methods: {
      setPhone: function (val) {
        this.phone = val
      },
      setCode: function (val) {
        this.code = val
      },
      checkUser: function () {
        this.errors = []
        this.message = ''

        let phone = this.phone.replace(/[^0-9.]/g, '').substr(1)

        let params = new FormData()
        params.append('userData', phone)
        params.append('type', 'login')

        this.$http.post('/ajax_new/User/isUser/', params).then(request => {
          if (request.data.status) {
            this.isUser = true
          } else {
            this.isUser = false
          }
        }).catch(error => {
          console.error(error)
        })
      },
      sendCode: function () {
        if (this.codeTimer > 0) {
          return
        }

        this.codeTimer = 0
        this.errors = []
        this.message = ''
        this.$v.phone.$touch()

        if (!this.$v.phone.$invalid) {
          this.isCodeSend = false

          let phone = this.phone.replace(/[^0-9.]/g, '').substr(1)

          let params = new FormData()
          params.append('phone', phone)
          params.append('type', 'forgot-pass')

          this.$http.post('/ajax_new/Code/send/', params).then(request => {
            if (request.data.status) {
              this.isCodeSend = true
              this.codeTimer = 60
              window.setInterval(() => {
                if (this.codeTimer > 0) {
                  this.codeTimer--
                }
              }, 1000)
            } else {
              this.phoneValid = false
            }
          }).catch(error => {
            console.error(error)
          })
        }
      },
      checkCode: function () {
        this.errors = []
        this.message = ''
        this.$v.phone.$touch()

        if (!this.isCodeSend) {
          return
        }

        if (!this.$v.phone.$invalid) {
          let phone = this.phone.replace(/[^0-9.]/g, '').substr(1)

          let params = new FormData()
          params.append('phone', phone)
          params.append('code', this.code)
          params.append('type', 'forgot-pass')

          this.$http.post('/ajax_new/Code/check/', params).then(request => {
            if (request.data.status) {
              this.isCodeSuccess = true
            } else {
              this.isCodeSuccess = false
            }
          }).catch(error => {
            console.error(error)
          })
        }
      },
      submit: async function (e) {
        this.errors = []
        this.message = ''
        this.$v.phone.$touch()

        let targetNode = e.target
        let action = targetNode.action

        if (!this.$v.$invalid) {
          let phone = this.phone.replace(/[^0-9.]/g, '').substr(1)

          await this.$recaptchaLoaded()
          const token = await this.$recaptcha('forgotPass')

          let params = new FormData()
          params.append('phone', phone)
          params.append('g-recaptcha-response', token)

          this.isAjax = true

          this.$http.post(action, params).then(request => {
            this.isAjax = false

            if (request.data.status) {
              window.location.href = request.data.data.redirect
            } else {
              this.issetUser = false
            }
          }).catch(error => {
            this.isAjax = false

            console.error(error)
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/components/forms/ForgotPass.vue